import { useEffect, useState } from 'react';

export default function InlineSVG({ url, color, className }) {
  const [svg, setSvg] = useState(null);

  useEffect(() => {
    if (!url) return;
    fetch(url)
      .then((res) => res.text())
      .then(setSvg)
      .catch(console.error);
  }, [url]);

  if (!svg) return null;

  return (
    <div
      className={className}
      style={{ color }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}